module.exports = __webpack_public_path__ + "img/10.7a269482.png";